import { MerchantId, SetHeaderService } from "@/helper/authenticationHelper";
import service from "../../baseHttpService";
import {
  PrepareCustomizeDocumentInputData,
  PrepareCustomizeDocumentPublicLinkInputData,
  PrepareCustomizeIdListInputData,
} from "./customizeFacade";

class DocumentService {
  DoGetCustomizeDocumentPublicLink(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareCustomizeDocumentPublicLinkInputData(input),
    };
    return service.peakOnlineView
      .post("/api/Customize/GetCustomizeDocumentPublicLink", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetCustomizeDocument(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareCustomizeDocumentInputData(input),
    };
    return service.peakOnlineView
      .post("/api/Customize/GetCustomizeDocument", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetCustomizeIdList(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareCustomizeIdListInputData(input),
    };
    return service.peakOnlineView.post("/api/Customize/GetCustomizeIdList", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoValidateRequestTaxInvoiceLink(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakAppConnect
      .post("/api/RequestTaxInvoice/ValidateLink", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoValidateRequestTaxInvoiceReceipt(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakAppConnect
      .post("/api/RequestTaxInvoice/GetValidateReceipt", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetRequestTaxInvoiceContact(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakAppConnect
      .post("/api/RequestTaxInvoice/GetValidateContact", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoSubmitRequestTaxInvoice(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakAppConnect
      .post("/api/RequestTaxInvoice/SubmitRequest", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new DocumentService();
